// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

/** The colour tokens of the active skin. Values live in theme/skins/<name>.ts. */
export const appColors = activeSkin.colors;

/** A `#RRGGBB` token at an opacity: alpha(appColors.neutral.black, 0.5) -> 'rgba(0,0,0,0.5)'. */
export function alpha(hex: string, opacity: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${opacity})`;
}

export default appColors;
